import React from 'react'
import cls from 'classnames'
import styled from 'styled-components'

export default class Progress extends React.Component {
  static defaultProps = {
    backgroundColor: '#f0f2f7',
    primaryColor: '#BBD3DE',
    size: '20px',
  }

  render() {
    const { id, backgroundColor, primaryColor, percent, size, className, innerPercent } =
      this.props

    return (
      <Stroke
        id={id}
        className={cls('is-progress', className)}
        backgroundColor={backgroundColor}
        size={size}
      >
        <Trail primaryColor={primaryColor} percent={percent} />
        {!!innerPercent && <Trail primaryColor="red" contrastColor="red" percent={innerPercent} />}
      </Stroke>
    )
  }
}

const Stroke = styled.div`
  width: 100%;
  height: ${(props) => props.size};
  border-radius: 15px;
  position: relative;
  background: ${(props) => props.backgroundColor};
`

const Trail = styled.div`
  position: absolute;
  top: 0;
  right: ${(props) => `${100 - props.percent}%`};
  bottom: 0;
  left: 0;
  border-radius: 15px;
  transition: ease-out 0.5s;
  background: ${(props) => props.primaryColor};
`
